import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'
import IntegrationAutosuggestCurrent from "./IntegrationAutosuggestCurrent";
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {compose} from 'redux'
import axios from "axios";
import _ from 'lodash';
import LocalizedStrings from 'react-localization';
import { data } from '../js/data.js';
import '../css/Destination.css';
import { fontSizeToggleAction } from '../js/actions/fontSizeToggleAction'

let strings = new LocalizedStrings(data);

function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
      
        <TextField
            onChange={{href: "#autocomplete2"}}
            fullWidth
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
            }}
            {...other}
        />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.label, query);
  const parts = parse(suggestion.label, matches);

  return (
      <MenuItem selected={isHighlighted} component="div">
        <a name="autocomplete2">
            <div>
                {parts.map((part, index) =>
                    part.highlight ? (
                        <span key={String(index)} style={{ fontWeight: 500 }}>
                            {part.text}
                        </span>
                    ) : (
                        <strong key={String(index)} style={{ fontWeight: 300 }}>
                            {part.text}
                        </strong>
                    ),
                )}
            </div>
          </a>
      </MenuItem>
  );
}

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

const styles = theme => ({
    root: {
        height: 250,
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
});

class Destination extends Component{
    state = {
      id: '',
      name:'',
      destination: '',
      single: '',
      popper: '',
      suggestions: [],
      dummy: []
    }

    getSuggestions = (value) => {
        var labels=[]
        var mapList=this.props.maps;
        for(var i = 0; i<mapList.length; i++){
            for(var j = 0; j<mapList[i].nodes.length; j++){
                if(mapList[i].nodes[j].type == 'place'){
                    labels.push({label: mapList[i].nodes[j].name, floor: mapList[i].floorNum})
                }
            }
        }
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;
    
        return inputLength === 0
            ? []
            : labels.filter(suggestion => {
                const keep =
                    count < 5 && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;
    
                if (keep) {
                    count += 1;
                }
    
                return keep;
            });
    }

    async componentDidMount(){

        await axios.get(`https://bcitrch-go.herokuapp.com/GetMapList`, {
            headers: {
                'Content-Type': 'text/plain;charset=utf-8'
            }
        })
            .then(res => {
                _.each(res.data.message.mapList, (item, index) => {
                    item.id = index;
                    this.setState({
                        dummy: [...this.state.dummy, item]
                    });
                });


            });

            this.handleSetState();

        
    }

    handleSetState(){
        var id = this.props.match.params.destination_id;
        this.setState({
            id: id
        });
        var mapList=this.props.maps;
        for(var i = 0; i<mapList.length; i++){
            for(var j = 0; j<mapList[i].nodes.length; j++){
                if(mapList[i].nodes[j].nodeId.trim().toLowerCase() == id.trim().toLowerCase()){
                    var name = mapList[i].nodes[j].name;
                    this.setState({
                        name: name
                    });
                    return;                  
                }
            }
        }
    }

    handleSuggestionsFetchRequested = ({ value }) => {
      this.setState({
          suggestions: this.getSuggestions(value),
      });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChange = name => (event, { newValue }) => {
        this.setState({
            [name]: newValue,
        });
        var mapList=this.props.maps;
        for(var i = 0; i<mapList.length; i++){
            for(var j = 0; j<mapList[i].nodes.length; j++){
                if(mapList[i].nodes[j].name == newValue){
                    this.setState({
                        destination: mapList[i].nodes[j].nodeId
                    })
                }
            }
        }
    };

    handleEmpty = () =>{
        alert("Please Enter a Location Name")
    }

    handleIncorrect = () =>{
        alert("Please Enter a Valid Location Name")
    }

    render(){
        strings.setLanguage(this.props.languages);

        const { classes } = this.props;

        const autosuggestProps = {
            renderInputComponent,
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            getSuggestionValue,
            renderSuggestion,
        };

        let enterButton;
        if(this.state.single == ''){
            enterButton = 
                <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                    style={{marginBottom: '10px'}}
                    onClick={this.handleEmpty}
                >
                    {strings.enter}
                </Button>
        } else if(this.state.destination != ''){
            enterButton = 
            <Link to={"/map/"+this.state.id+"&"+this.state.destination}>
                <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                    style={{marginBottom: '10px'}}
                >
                    {strings.enter}
                </Button>
            </Link>
        } else {
            enterButton = 
                <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                    style={{marginBottom: '10px'}}
                    onClick={this.handleIncorrect}
                >
                    {strings.enter}
                </Button>
        }

        return(
            <div className="App">

            <header className="App-header">
              <p className="Title-one">
                <span className={(this.props.isFontSizeEnabled ? 'Dest-title-one-large' : 'Dest-title-one')}>
                    {strings.youAreAt}
                </span><br/>
                <span className={(this.props.isFontSizeEnabled ? 'Dest-title-two-large' : 'Dest-title-two')}>
                  {this.state.name}
                </span><br/>
                <span className={(this.props.isFontSizeEnabled ? 'Dest-title-three-large' : 'Dest-title-three')}>
                  {strings.whereTo}
                </span>
              </p>
              
              <div>
                    <div className={classes.root}>
                        <Autosuggest
                            {...autosuggestProps}
                            inputProps={{
                                id: (this.props.isFontSizeEnabled ? 'Cur-loc-large' : 'Cur-loc'),
                                classes,
                                placeholder: (strings.enterDestination),
                                value: this.state.single,
                                onChange: this.handleChange('single'),
                            }}
                            theme={{
                                container: classes.container,
                                suggestionsContainerOpen: classes.suggestionsContainerOpen,
                                suggestionsList: classes.suggestionsList,
                                suggestion: classes.suggestion,
                            }}
                            renderSuggestionsContainer={options => (
                                <Paper {...options.containerProps} square>
                                    {options.children}
                                </Paper>
                            )}
                        />
                    </div>
                    <div>
                        {enterButton}
                    </div>
                    <div >
                            <Link to="/">
                                <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                                    style={{marginBottom: '10px'}}
                                    >
                                        {strings.back}
                                </Button>
                            </Link>
                    </div>
                    <div id="fontButtons">
                        <Button id="Font-size-toggle-button"
                            onClick={this.props.fontSizeToggleAction}
                            style= {
                                {
                                    borderRadius: '2px',
                                    width: '60px',
                                    border: 'solid 1px #d8dde3',
                                    borderColor: '#000'
                                }
                            }
                        >
                            <i class="material-icons">text_fields</i>
                        </Button>
                    </div>
                </div>
              
            </header>
      </div>
            
        )
    }
}

IntegrationAutosuggestCurrent.propTypes = {
    classes: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => {
    return {
        maps: state.maps.maps,
        isFontSizeEnabled: state.isFontSizeEnabled.isFontSizeEnabled,
        languages: state.language.language
    }
}
const mapDispatchToProps = dispatch => ({
    fontSizeToggleAction: () => dispatch(fontSizeToggleAction),
  });
  
  export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Destination);
